module.exports = global["PropTypes"] = require("-!./index.js");